import React from 'react'
import PropTypes from 'prop-types'

// Hooks
import { useBuyerSettings } from '../../hooks/buyerSettings'

// Constants
import {
  OWNER_TYPES,
  RENTER_TYPES,
  GUEST_TYPES,
} from '../../constants/buyerSettings'

export const If = ({ condition, children }) => (condition ? children : null)
If.propTypes = {
  condition: PropTypes.any,
}

export const Unless = ({ condition, children }) =>
  !condition ? children : null
Unless.propTypes = {
  condition: PropTypes.any,
}

const IfOwner = ({ children }) => {
  const { clientType } = useBuyerSettings()

  return OWNER_TYPES.includes(clientType) ? children : <React.Fragment />
}
IfOwner.propTypes = {
  children: PropTypes.any,
}
If.Own = IfOwner

const UnlessOwner = ({ children }) => {
  const { clientType } = useBuyerSettings()

  return OWNER_TYPES.includes(clientType) ? <React.Fragment /> : children
}
UnlessOwner.propTypes = {
  children: PropTypes.any,
}
Unless.Own = UnlessOwner

const IfRenter = ({ children }) => {
  const { clientType } = useBuyerSettings()

  return RENTER_TYPES.includes(clientType) ? children : <React.Fragment />
}

IfRenter.propTypes = {
  children: PropTypes.any,
}

If.Rent = IfRenter

const IfGuest = ({ children }) => {
  const { clientType } = useBuyerSettings()

  return GUEST_TYPES.includes(clientType) ? children : null
}

IfGuest.propTypes = {
  children: PropTypes.any,
}

If.Guest = IfGuest

export const Show = ({ condition, children, ...restProps }) => (
  <div
    {...restProps}
    style={condition ? { height: '100%' } : { display: 'none' }}
  >
    {children}
  </div>
)

Show.propTypes = {
  condition: PropTypes.any,
  children: PropTypes.any,
}
